document.documentElement.classList.remove('no-js');

(() => {
  const body = document.body;
  let cartOpener = null;

  const closeMenu = () => {
    body.classList.remove('menu-open');
    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
  };

  const setCartOpen = (open, opener = null) => {
    body.classList.toggle('cart-open', open);
    const drawer = document.querySelector('[data-cart-drawer]');
    const scrim = document.querySelector('.room-scrim');
    if (open && opener) cartOpener = opener;
    if (drawer) {
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      drawer.toggleAttribute('inert', !open);
    }
    if (scrim) scrim.hidden = !open;
    document.querySelectorAll('[data-cart-open]').forEach((trigger) => trigger.setAttribute('aria-expanded', open ? 'true' : 'false'));
    if (open) drawer?.querySelector('[data-cart-close]')?.focus();
    else if (cartOpener?.isConnected) {
      cartOpener.focus();
      cartOpener = null;
    }
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = count;
      node.setAttribute('aria-label', `${count} items in cart`);
    });
  };

  const changeCartItem = async (key, quantity) => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) }),
    });
    if (!response.ok) throw new Error('Cart update failed');
    await refreshCartDrawer(true);
  };

  const refreshCartDrawer = async (open = true) => {
    const [sectionResponse, cartResponse] = await Promise.all([
      fetch(`${window.Shopify?.routes?.root || '/'}?section_id=cart-drawer`),
      fetch(`${window.Shopify?.routes?.root || '/'}cart.js`),
    ]);
    if (!sectionResponse.ok || !cartResponse.ok) throw new Error('Cart refresh failed');

    const sectionMarkup = await sectionResponse.text();
    const cart = await cartResponse.json();
    const parsed = new DOMParser().parseFromString(sectionMarkup, 'text/html');
    const currentSection = document.querySelector('#shopify-section-cart-drawer');
    const nextSection = parsed.querySelector('#shopify-section-cart-drawer');
    if (currentSection && nextSection) currentSection.innerHTML = nextSection.innerHTML;
    updateCartCount(cart.item_count);
    if (open) setCartOpen(true);
  };

  const setButtonLoading = (button, loading) => {
    if (!button) return;
    if (loading) {
      button.dataset.label = button.textContent;
      button.textContent = 'Adding…';
      button.disabled = true;
    } else {
      button.textContent = button.dataset.label || 'Add to cart';
      const select = button.closest('form')?.querySelector('[data-variant-select]');
      const selectedOption = select?.options[select.selectedIndex];
      button.disabled = selectedOption ? selectedOption.dataset.available !== 'true' : false;
    }
  };

  document.addEventListener('click', async (event) => {
    const cartOpen = event.target.closest('[data-cart-open]');
    const cartClose = event.target.closest('[data-cart-close]');
    const menuToggle = event.target.closest('[data-menu-toggle]');
    const removeButton = event.target.closest('[data-cart-remove]');
    const quantityButton = event.target.closest('[data-cart-quantity]');
    const stickyAdd = event.target.closest('[data-sticky-add]');

    if (cartOpen) {
      event.preventDefault();
      closeMenu();
      setCartOpen(true, cartOpen);
    }
    if (cartClose) {
      event.preventDefault();
      setCartOpen(false);
    }
    if (menuToggle) {
      const expanded = body.classList.toggle('menu-open');
      menuToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
    if (removeButton) {
      event.preventDefault();
      removeButton.disabled = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: removeButton.dataset.cartRemove, quantity: 0 }),
        });
        if (!response.ok) throw new Error('Item removal failed');
        await refreshCartDrawer(true);
      } catch (error) {
        removeButton.disabled = false;
        console.error(error);
      }
    }
    if (quantityButton) {
      quantityButton.disabled = true;
      try {
        await changeCartItem(quantityButton.dataset.cartQuantity, quantityButton.dataset.quantity);
      } catch (error) {
        quantityButton.disabled = false;
        console.error(error);
      }
    }
    if (stickyAdd) {
      document.querySelector('[data-product-root] [data-ajax-product-form]')?.requestSubmit();
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ajax-product-form]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const errorNode = form.querySelector('[data-product-error]');
    setButtonLoading(button, true);
    if (errorNode) errorNode.textContent = '';

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Could not add this item.');
      }
      cartOpener = button;
      await refreshCartDrawer(true);
    } catch (error) {
      if (errorNode) errorNode.textContent = error.message;
      console.error(error);
    } finally {
      setButtonLoading(button, false);
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    select.classList.add('is-selected');
    const option = select.options[select.selectedIndex];
    const price = select.closest('[data-product-root]')?.querySelector('[data-product-price]');
    const submit = select.closest('form')?.querySelector('[type="submit"]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const stickyButton = document.querySelector('[data-sticky-add]');
    if (stickyPrice && option.dataset.price) stickyPrice.textContent = option.dataset.price;
    if (submit) {
      const available = option.dataset.available === 'true';
      submit.disabled = !available;
      submit.textContent = available ? 'Add to bag ↗' : 'Sold out';
      submit.dataset.label = submit.textContent;
      if (stickyButton) {
        stickyButton.disabled = !available;
        stickyButton.textContent = available ? 'Add to bag ↗' : 'Sold out';
      }
    }
  });

  const mainAddButton = document.querySelector('[data-product-root] [data-ajax-product-form] > .room-button');
  const stickyProduct = document.querySelector('[data-sticky-product]');
  if (mainAddButton && stickyProduct && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver(([entry]) => {
      const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyProduct.classList.toggle('is-visible', visible);
      stickyProduct.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyProduct.toggleAttribute('inert', !visible);
    });
    stickyObserver.observe(mainAddButton);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' && body.classList.contains('cart-open')) {
      const drawer = document.querySelector('[data-cart-drawer]');
      const focusable = [...(drawer?.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])') || [])]
        .filter((node) => node.getClientRects().length > 0);
      if (focusable.length) {
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
    if (event.key === 'Escape') {
      setCartOpen(false);
      closeMenu();
    }
  });
})();
